import Dialog from '@/components/Dialog';
import mediaQuery from '@/lib/styling/mediaQuery';
import styled from '@emotion/styled';

const SelectWrapper = styled(Dialog.Content)({
  paddingTop: 0,
  display: 'flex',
  alignItems: 'center',
  label: {
    marginRight: 12,
    fontFamily: 'CircularStd',
  },
  '.MuiSelect-root': {
    width: 256,
  },
  '.MuiIconButton-root': {
    marginLeft: 7,
  },
  [mediaQuery(500)]: {
    '.MuiSelect-root': {
      width: 50,
      flex: 1,
    },
  },
});

export default SelectWrapper;
